/*
/ Helper file for getting and setting values to the browser storage
*/

export function getSessionStorage(key, type) {
  if (type !== 'Filters') {
    return sessionStorage.getItem(`${key}_${type}`)
  }

  return JSON.parse(sessionStorage.getItem(`${key}_${type}`))
}

export function setSessionStorage(key, type, data) {
  if (type !== 'Filters') {
    sessionStorage.setItem(`${key}_${type}`, data)
  } else {
    sessionStorage.setItem(`${key}_${type}`, JSON.stringify(data))
  }
}

export function getLocalStorage(key, type) {
  if (type !== 'Filters') {
    return localStorage.getItem(`${key}_${type}`)
  }
  
  return JSON.parse(localStorage.getItem(`${key}_${type}`))
}

export function setLocalStorage(key, type, data) {
  if (type !== 'Filters') {
    localStorage.setItem(`${key}_${type}`, data)
  } else {
    localStorage.setItem(`${key}_${type}`, JSON.stringify(data))
  }
}
